import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { AiOutlineDelete } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import { Pack, UITrack, User } from "../../firebase/firestore";
import { prettyDate } from "../../utils/dates";
import { ActionsType } from "../misc/Actions";

export type Selectable = {
  selectable?: boolean;
  onSelect?: () => any;
  onDeselect?: () => any;
  selected?: boolean;
};
export type TrackRowProps = {
  uiTrack: UITrack;
  uploadProgress?: number;
  className?: string;
  playable?: "inline" | "global";
  actions?: ActionsType;
  editable?: boolean; // can edit info inline (title, bpm, key, etc)
  creator?: User;
  onDelete?: () => any;
  idx?: number;
  downloadable?: boolean;
  compact?: boolean;
  showCreator?: boolean;

  // if the track is rendered in the context of a pack (used to attribute downloads from a pack)
  pack?: Pack;
} & Selectable;

export function TrackRowSelectable({
  uiTrack,
  uploadProgress,
  onDelete = null,
  selected,
  onDeselect,
  onSelect,
  selectable,
  className,
  ...rest
}: TrackRowProps) {
  const uploading = uploadProgress !== undefined && uploadProgress !== 100;
  const { track } = uiTrack;
  return (
    <div
      className={`${className} group h-7 relative p-4 transition hover:bg-bgactive  rounded  cursor-pointer flex items-center justify-between  ${
        uploading && "opacity-50"
      }`}
      onClick={() => selectable && (!selected ? onSelect() : onDeselect())}
    >
      <div className="flex grow items-center">
        {selectable && (
          <input
            type="checkbox"
            onChange={(e) => (selected ? onDeselect() : onSelect())}
            checked={selected}
            className="z-10 mr-2 w-4 h-4"
          />
        )}

        {/* {uploadProgress && <div className={"transition-all z-0 absolute top-0 left-0 h-full bg-slate-400"} style={{ width: `${uploadProgress}%` }}></div>} */}
        <div className="w-2/3 flex">
          <div>
            {track.title}{" "}
            {track?.stems?.length ? (
              <span className="text-xs text-light-gray"> + {track.stems.length} stems</span>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <div className=" transition text-light-gray text-sm" style={{ opacity: uploading ? 0 : 1 }}>
          {track?.uploadDate?.toDate &&
            prettyDate(track?.uploadDate?.toDate ? track.uploadDate?.toDate() : track.uploadDate)}
        </div>

        <div
          className={`relative ml-4 ${
            !uploading && "opacity-0"
          } group-hover:opacity-100 cursor-pointer transition-opacity`}
        >
          {onDelete && !uploading && (
            <span onClick={() => onDelete()} className="  ">
              <AiOutlineDelete width={18} size={18} className={"opacity-75 hover:opacity-100"} />
            </span>
          )}

          {onDelete && uploading && (
            <div onClick={onDelete} className=" relative h-4 w-4 cursor-pointer  ">
              <IoMdClose
                id="del-track"
                width={10}
                size={10}
                className={"absolute w-3 h-3 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"}
              />
              <CircularProgressbar
                className="absolute w-4 h-4 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                styles={buildStyles({
                  trailColor: `transparent`,
                  pathColor: "white",
                })}
                value={uploadProgress}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function TrackRowCompact({
  uiTrack,
  uploadProgress,
  onDelete = null,
  selected,
  onDeselect,
  onSelect,
  selectable,
  className,
  ...rest
}: TrackRowProps) {
  const uploading = uploadProgress !== undefined && uploadProgress !== 100;
  const { track } = uiTrack;
  return (
    <div
      className={`${className} group h-7 relative p-4 transition hover:bg-bgactive  rounded  cursor-pointer flex items-center justify-between  ${
        uploading && "opacity-50"
      }`}
      onClick={() => selectable && (!selected ? onSelect() : onDeselect())}
    >
      <div className="flex grow items-center">
        {selectable && (
          <input
            type="checkbox"
            onChange={(e) => (selected ? onDeselect() : onSelect())}
            checked={selected}
            className="z-10 mr-2 w-4 h-4"
          />
        )}

        {/* {uploadProgress && <div className={"transition-all z-0 absolute top-0 left-0 h-full bg-slate-400"} style={{ width: `${uploadProgress}%` }}></div>} */}
        <div className="w-2/3 flex">
          <div>
            {track.title}{" "}
            {track?.stems?.length ? (
              <span className="text-xs text-light-gray"> + {track.stems.length} stems</span>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <div className=" transition text-light-gray text-sm" style={{ opacity: uploading ? 0 : 1 }}>
          {prettyDate(track.uploadDate.toDate ? track.uploadDate?.toDate() : track.uploadDate)}
        </div>

        <div
          className={`relative ml-4 ${
            !uploading && "opacity-0"
          } group-hover:opacity-100 cursor-pointer transition-opacity`}
        >
          {onDelete && !uploading && (
            <span onClick={() => onDelete()} className="  ">
              <AiOutlineDelete width={18} size={18} className={"opacity-75 hover:opacity-100"} />
            </span>
          )}

          {onDelete && uploading && (
            <div onClick={onDelete} className=" relative h-4 w-4 cursor-pointer  ">
              <IoMdClose
                id="del-track"
                width={10}
                size={10}
                className={"absolute w-3 h-3 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"}
              />
              <CircularProgressbar
                className="absolute w-4 h-4 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                styles={buildStyles({
                  trailColor: `transparent`,
                  pathColor: "white",
                })}
                value={uploadProgress}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
